export const FILTER_START_DATE_RANGE_KEY = 'startDate';
export const FILTER_END_DATE_RANGE_KEY = 'endDate';
export const TODAY_CHECKBOX_KEY = 'today';
export const DATE_FORM_FILED_KEYS = [FILTER_START_DATE_RANGE_KEY, FILTER_END_DATE_RANGE_KEY];
export const FIELD_KEYS_WITH_DATE_RANGE_EXCEED_LIMIT_VALIDATOR = ['pickupPlanningHeaderRangePicker'];

export const INVALID_DATE_RANGE_ERROR = 'invalidDateRange';
export const DATE_RANGE_LIMIT = 5;
export const DATE_RANGE_LIMIT_ERROR = 'dateRangeExceedsLimit';

export const TIME_RANGE_START_KEY = 'startTime';
export const TIME_RANGE_END_KEY = 'endTime';
export const HOURS_KEY = 'hours';
export const MINUTES_KEY = 'minutes';
export const INVALID_TIME_RANGE_ERROR = 'invalidTimeRange';
export const INVALID_TIME_ERROR = 'invalidTime';

export const NUMBER_RANGE_START_KEY = 'from';
export const NUMBER_RANGE_END_KEY = 'to';

export const MAX_FIELD_LENGTH = 255;

export const HEADER_FILTERS_STORAGE_KEY = 'pickupHeaderFilters';
export const CUSTOMER_COMMUNICATION_HEADER_FILTERS_STORAGE_KEY = 'customerCommunicationHeaderFilters';
export const DATE_RANGE_DEAULT_VALUES = {
    startDate: new Date(),
    endDate: new Date()
};

export const DATE_TIME_DEFAULT_VALUES = {
    date: {
        startDate: new Date(),
        endDate: new Date()
    },
    time: {
        startTime: {
            hours: '00',
            minutes: '00'
        },
        endTime: {
            hours: '23',
            minutes: '59'
        }
    }
};